export default {
    created() {

        const queryHandlers = {
            vkExists: {
                action: route => ({ ...route.query, vkExists: undefined }),
                toast: 'toast.vkExists'
            },
            registerVK: {
                action: route => ({ ...route.query, registerVK: undefined }),
                toast: 'toast.vkIdDoesntExist',
                setTab: true
            }
        };

        Object.entries(queryHandlers).forEach(([ key, handler ]) => {
            if (this.$route.query[key] === '1') {
                this.$router.replace({ query: handler.action(this.$route) });
                this.$toast.warning(this.$t(handler.toast), '', { position: 'topRight' });

                if (handler.setTab)
                    this.tabIndex = 1;
            }
        });
    }
};
